(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["evacuate-from-meaning-main"] = factory();
	else
		root["evacuate-from-meaning-main"] = factory();
})(window, () => {
return 